export default {"src":"/_next/static/media/srg.3119d354.svg","height":30,"width":140,"blurWidth":0,"blurHeight":0};